import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalIncertidumbre({ reset }) {
  return (
    <Container className="form-container text-center">

      <h2 className="form-title">¡Queremos acompañarte! ¡Felicitaciones por querer terminar el liceo!</h2>
      <p>
        Por favor, dirigite al liceo público más cercano y solicitá tu escolaridad para saber cuántas materias te quedan y volvé a completar este formulario para que podamos apoyarte.
      </p>

      {/* Botón para reiniciar */}
      <Button
        variant="primary"
        onClick={reset}
        className="mt-2 me-2"
      >
        Volver al inicio
      </Button>
    </Container>
  );
}
